import React from "react";
import { Helmet } from "react-helmet-async";
export default function ForgotPasswordPage() {
    
    return (
        <section>
            <Helmet bodyAttributes={{ class: 'login-back' }}>
                <title>Forgot Password | sec1.io</title>
            </Helmet>

            <section className="mb-8 vh-100 d-flex align-items-center justify-content-center bg-customDark">
                
            </section>
        </section>
    );
}